var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VLayout',{attrs:{"title":_vm.$t('home_user.my_account'),"subtitle":_vm.$t('home_user.welcome')}},[_c('div',[_c('VListCardHomeLinks')],1),_c('VButtonGroup',{attrs:{"hide_primary":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }